import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Country, I18nModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { Option } from '../../../../../../core/models/option.model';
import { CountriesDropdownComponent } from '../../../../../../components/form-elements/countries-dropdown/countries-dropdown.component';

@Component({
  selector: 'form-contact',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, CountriesDropdownComponent],
  templateUrl: './form-contact.component.html',
  styleUrl: './form-contact.component.scss',
})
export class FormContactComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() countries$: Observable<Country[]> = of([]);
  @Input() businessTypes$: Observable<Option[]> = of([]);
  @Input() stateRegions$: Observable<Option[]> = of([]);
  @Output() _onSubmit = new EventEmitter();

  country?: Country;

  ngOnInit(): void {
    this.country = { isocode: this.form.get('country')?.value };
  }

  setCountry(country: Country) {
    if (country) {
      this.country = country;
      this.form.get('country')?.setValue(country.isocode);
    }
  }

  validateInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9()-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  submit() {
    this._onSubmit.emit();
  }
}
